module.exports = __webpack_public_path__ + "media/images/check-out-button-83d8a53c5fc7c731bd7bd3ca17c07ce1.png";